<template>
    <div
        :class="{
            'patsnap-biz-suggestion_board': true,
            'ai-common-suggestion-board': true,
            'ai-common-suggestion-board--default-status': defaultStatus
        }"
    >
        <iframe
            src=""
            style="top: 0px; width: 100%; height: 100%; display: block; position: absolute; border: none; z-index: -100"
        />
        <div class="ai-common-suggestion-board__modal">
            <!-- TO FIX IE9 z-index -->
            <div
                v-for="({ section,title, content }) in suggestionList"
                :key="section"
            >
                <BlockKeywordQuery
                    v-if="section === SECTION_TYPE_KEYWORDS"
                    class="ai-common-suggestion-board__block"
                    :items="content"
                    :keyword="stemKeyword"
                    @select="handleSelectKeywordQuery"
                />
                <Component
                    :is="section === SECTION_TYPE_FIELD ? 'BlockFields': 'BlockSuggestion'"
                    :title="title"
                    :items="content"
                    :selected-index="selectedIndex"
                    :on-click="onClick"
                    :update-selected-index="updateSelectedIndex"
                    :class="{
                        'ai-common-suggestion-board__block': true,
                        'ai-common-suggestion-normal': section !== SECTION_TYPE_KEYWORDS,
                        'ai-common-suggestion-keywords': section === SECTION_TYPE_KEYWORDS,
                        'ai-common-suggestion-sample':section === SECTION_TYPE_SAMPLE
                    }"
                />
            </div>

            <!-- 以下部分只会在 defaultStatus: true 时显示-->
            <BlockFields
                :title="$t('smartSearch.sections.keywordFields')"
                :items="keywordFields"
                :selected-index="selectedIndex"
                :on-click="onClick"
                :update-selected-index="updateSelectedIndex"
                class="ai-common-suggestion-board__block ai-common-suggestion-board__block--half-width"
                style="padding-right: 40px;"
            />

            <BlockFields
                :title="$t('smartSearch.sections.assigneeFields')"
                :items="assigneeFields"
                :selected-index="selectedIndex"
                :on-click="onClick"
                :update-selected-index="updateSelectedIndex"
                class="ai-common-suggestion-board__block ai-common-suggestion-board__block--half-width"
            />

            <BlockFields
                :title="$t('smartSearch.sections.classificationNumberFields')"
                :items="classificationNumberFields"
                :selected-index="selectedIndex"
                :on-click="onClick"
                :update-selected-index="updateSelectedIndex"
                class="ai-common-suggestion-board__block ai-common-suggestion-board__block--half-width"
                style="padding-right: 40px;"
            />

            <BlockFields
                :title="$t('smartSearch.sections.otherFields')"
                :items="otherFields"
                :selected-index="selectedIndex"
                :on-click="onClick"
                :update-selected-index="updateSelectedIndex"
                class="ai-common-suggestion-board__block ai-common-suggestion-board__block--half-width"
            />

            <div
                v-if="defaultStatus"
                class="ai-common-suggestion-board__syntax-helper"
            >
                <a
                    href="javascript:void(0)"
                    @mousedown.prevent
                    @click.prevent="goSearchHelper"
                >{{ $t('smartSearch.syntaxHelper') }}</a>
            </div>
        </div>
    </div>
</template>

<script>
import get from 'lodash/get';
import includes from 'lodash/includes';
import forEach from 'lodash/forEach';
import { BlockSuggestion, BlockFields } from './blocks';
import {
    DEFAULT_KEYWORD_FIELDS,
    DEFAULT_ASSIGNEE_FIELDS,
    DEFAULT_CLASSIFICATION_NUMBER_FIELDS,
    DEFAULT_OTHER_FIELDS,
    SECTION_TYPE_FIELD,
    SECTION_TYPE_KEYWORDS,
    SECTION_TYPE_HISTORY,
    SECTION_TYPE_SAMPLE,
} from './constants';
import { messages } from '../locales';
import BlockKeywordQuery from './components/BlockKeywordQuery.vue';

export default {
    name: 'PtSuggestionBoard',
    i18n: {
        fallbackLocale: 'cn',
        messages,
    },
    components: {
        BlockSuggestion,
        BlockFields,
        BlockKeywordQuery,
    },
    props: {
        suggestion: {
            type: Array,
            default() {
                return [];
            },
        },
        selectedIndex: {
            type: Number,
            default: -1,
        },
        defaultStatus: {
            type: Boolean,
            default: true,
        },
        analyticsDomain: {
            type: String,
            default: '',
        },
        stemKeyword: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            keywordFields: [],
            assigneeFields: [],
            classificationNumberFields: [],
            otherFields: [],
        };
    },
    computed: {
        suggestionList() {
            const suggestion = this.suggestion.map((item) => {
                const title = this.$t(`smartSearch.sections.${item.section}`);
                return { title, ...item };
            });
            // 默认状态下，只保留历史记录，这是为了防止外部错误传入
            if (this.defaultStatus) {
                return suggestion.filter(({ section }) => section === SECTION_TYPE_HISTORY);
            }
            return suggestion;
        },
        lang() {
            const lang = get(this, '$i18n.locale', 'en');
            return lang;
        },
    },
    watch: {
        suggestion: {
            handler(items) {
                this.generateSampleGroupSuggestions(items);
            },
            immediate: true,
        },
    },
    created() {
        this.SECTION_TYPE_FIELD = SECTION_TYPE_FIELD;
        this.SECTION_TYPE_KEYWORDS = SECTION_TYPE_KEYWORDS;
        this.SECTION_TYPE_SAMPLE = SECTION_TYPE_SAMPLE;
    },
    methods: {
        onClick(e, item) {
            this.$emit('select', item);
            e.preventDefault();
            e.stopPropagation();
        },
        generateSampleGroupSuggestions(items) {
            const { defaultStatus } = this;
            this.keywordFields = [];
            this.assigneeFields = [];
            this.classificationNumberFields = [];
            this.otherFields = [];

            if (!defaultStatus) return;

            forEach(items, ({ section, content }) => {
                if (section !== SECTION_TYPE_FIELD) return;
                forEach(content, (data) => {
                    const { name } = data;
                    if (includes(DEFAULT_KEYWORD_FIELDS, name)) {
                        this.keywordFields.push(data);
                    } else if (includes(DEFAULT_ASSIGNEE_FIELDS, name)) {
                        this.assigneeFields.push(data);
                    } else if (includes(DEFAULT_CLASSIFICATION_NUMBER_FIELDS, name)) {
                        this.classificationNumberFields.push(data);
                    } else if (includes(DEFAULT_OTHER_FIELDS, name)) {
                        this.otherFields.push(data);
                    }
                });
            });
        },
        updateSelectedIndex(index) {
            this.$emit('update-selected-index', index);
        },
        goSearchHelper() {
            const link = this.analyticsDomain ? `${this.analyticsDomain}/search_helper` : '/search_helper';
            window.open(link);
        },

        handleSelectKeywordQuery(query) {
            this.$emit('select-query', query);
        },
    },
};
</script>
